module.exports = (__webpack_public_path__ || '') + "static/images/photo-13-bb42fe5d864125591970c6fd0b85ccc0.jpg";